import type { LocaleCode } from "./fixtures.js";

export type ShellCopy = {
  appName: string;
  environment: string;
  organization: string;
  welcomeTitle: string;
  welcomeSubtitle: string;
  discoverOrganizations: string;
  requestConnection: string;
  connectionRequested: string;
  connectionRequests: string;
  connectionPolicy: string;
  communityEvents: string;
  createDonation: string;
  openConnection: string;
  firstDonation: string;
  donationTotal: string;
  latestDonation: string;
  stripeConnect: string;
  stripeConnectHealth: string;
  commerceReadiness: string;
  commerceOnboardingStatus: string;
  commerceCharges: string;
  commercePayouts: string;
  commerceDetailsSubmitted: string;
  commerceRequirementsDue: string;
  commerceLastSync: string;
  commerceFinanceOnly: string;
  startStripeConnectOnboarding: string;
  resumeStripeConnectOnboarding: string;
  refreshStripeConnectStatus: string;
  stripeConnectNoPayments: string;
  ramadanOperations: string;
  ramadanCommandCenter: string;
  ramadanTodayTonight: string;
  ramadanPrayerSchedule: string;
  ramadanTaraweeh: string;
  ramadanQiyam: string;
  ramadanIftarCapacity: string;
  ramadanSponsors: string;
  ramadanTransfers: string;
  ramadanAttentionNeeded: string;
  ramadanReadiness: string;
  ramadanCommunications: string;
  ramadanModeEditor: string;
  ramadanModeId: string;
  ramadanTitle: string;
  ramadanTitleAr: string;
  ramadanSummary: string;
  ramadanSummaryAr: string;
  ramadanSlotPriceUsd: string;
  saveRamadanMode: string;
  resetRamadanModeForm: string;
  iftarSlotEditor: string;
  iftarSlotId: string;
  iftarModeId: string;
  iftarDayNumber: string;
  iftarSlotLabel: string;
  iftarSlotLabelAr: string;
  iftarAmountUsd: string;
  saveIftarSlot: string;
  resetIftarSlotForm: string;
  iftarSponsorships: string;
  ramadanAdminNotes: string;
  saveRamadanAdminNote: string;
  resetRamadanAdminNoteForm: string;
  availableSlots: string;
  reserveIftarSlot: string;
  latestSponsorship: string;
  reserveSpace: string;
  spaces: string;
  spaceEditor: string;
  spaceId: string;
  spaceCampus: string;
  spaceNoCampus: string;
  spaceType: string;
  spaceStatus: string;
  spaceVisibility: string;
  spaceName: string;
  spaceNameAr: string;
  spaceDescription: string;
  spaceDescriptionAr: string;
  spaceLocation: string;
  spaceCapacity: string;
  spaceAmenities: string;
  spaceAccessibilityFeatures: string;
  spaceAccessibilityNotes: string;
  spaceAccessibilityNotesAr: string;
  spacePrimaryImageStoragePath: string;
  spacePrimaryImageAltText: string;
  spacePrimaryImageAltTextAr: string;
  spaceTimezone: string;
  spaceOperatingHours: string;
  spaceMondayHours: string;
  spaceTuesdayHours: string;
  spaceWednesdayHours: string;
  spaceThursdayHours: string;
  spaceFridayHours: string;
  spaceSaturdayHours: string;
  spaceSundayHours: string;
  spaceHourlyPriceUsd: string;
  saveSpace: string;
  resetSpaceForm: string;
  spaceAvailabilityBlocks: string;
  spaceAvailabilityBlockEditor: string;
  spaceAvailabilityBlockId: string;
  spaceAvailabilityBlockType: string;
  spaceAvailabilityBlockStartsAt: string;
  spaceAvailabilityBlockEndsAt: string;
  spaceAvailabilityBlockLabel: string;
  spaceAvailabilityBlockLabelAr: string;
  spaceAvailabilityBlockInternalReason: string;
  spaceAvailabilityBlockPublicReason: string;
  saveSpaceAvailabilityBlock: string;
  resetSpaceAvailabilityBlockForm: string;
  spaceReservationRequests: string;
  pendingSpaceReservationRequests: string;
  approvedSpaceReservationSchedule: string;
  canonicalSpaceReservations: string;
  approveSpaceReservation: string;
  rejectSpaceReservation: string;
  cancelSpaceReservation: string;
  availableSpaceSlots: string;
  spaceSlotEditor: string;
  spaceSlotId: string;
  spaceSlotSpaceId: string;
  spaceSlotLabel: string;
  spaceSlotLabelAr: string;
  spaceSlotStartsAt: string;
  spaceSlotEndsAt: string;
  spaceSlotAmountUsd: string;
  saveSpaceSlot: string;
  resetSpaceSlotForm: string;
  latestReservation: string;
  publishSpace: string;
  organizationProfileEditor: string;
  organizationIdentityDetails: string;
  organizationDisplayName: string;
  organizationLogoStoragePath: string;
  organizationLogoFile: string;
  organizationLocationDetails: string;
  organizationAddressLine1: string;
  organizationAddressLine2: string;
  organizationCity: string;
  organizationRegion: string;
  organizationPostalCode: string;
  organizationCountry: string;
  organizationTimeZone: string;
  organizationPublicContact: string;
  organizationNoPublicContact: string;
  organizationPublicEmail: string;
  organizationPublicPhone: string;
  organizationWebsiteUrl: string;
  organizationPublicVisibility: string;
  organizationVisibilityDirectory: string;
  organizationVisibilityDiscovery: string;
  organizationVisibilityProfile: string;
  organizationBrandColor: string;
  organizationCategory: string;
  organizationConnectionPolicy: string;
  policyOpen: string;
  policyApprovalRequired: string;
  organizationWelcomeCopy: string;
  organizationHeadline: string;
  organizationHeadlineAr: string;
  organizationSummary: string;
  organizationSummaryAr: string;
  saveOrganizationProfile: string;
  resetOrganizationProfileForm: string;
  editOrganizationProfile: string;
  organizationProfileAudit: string;
  prayerTimesSettings: string;
  prayerTimesEnabled: string;
  prayerTimesMobileVisibility: string;
  configurePrayerTimes: string;
  prayerProvider: string;
  prayerAddress: string;
  prayerCalculationMethod: string;
  prayerSchool: string;
  prayerLatitudeAdjustment: string;
  prayerIqamaTimes: string;
  prayerTimingsDate: string;
  prayerSource: string;
  prayerFajr: string;
  prayerSunrise: string;
  prayerDhuhr: string;
  prayerAsr: string;
  prayerMaghrib: string;
  prayerIsha: string;
  prayerJumuah: string;
  adhan: string;
  iqamah: string;
  savePrayerSettings: string;
  resetPrayerSettingsForm: string;
  peopleManager: string;
  approveConnection: string;
  rejectConnection: string;
  connectionDecisions: string;
  communityEngagement: string;
  imamContent: string;
  imamContentEditor: string;
  imamContentId: string;
  imamContentStatus: string;
  imamContentTitle: string;
  imamContentTitleAr: string;
  imamContentSubtitle: string;
  imamContentSubtitleAr: string;
  imamContentBody: string;
  imamContentBodyAr: string;
  imamContentImagePath: string;
  imamContentImageAlt: string;
  imamContentImageAltAr: string;
  imamContentImageFile: string;
  imamContentGalleryImageFiles: string;
  imamContentYoutubeUrl: string;
  imamContentDraft: string;
  imamContentPublished: string;
  imamContentArchived: string;
  publishImamContent: string;
  disableImamContent: string;
  deleteImamContent: string;
  imamContentSortOrder: string;
  imamContentFeatured: string;
  imamContentEmpty: string;
  newImamContent: string;
  editImamContent: string;
  imamContentImagePreview: string;
  imamContentMedia: string;
  imamContentActions: string;
  saveImamContent: string;
  resetImamContentForm: string;
  announcements: string;
  communityTimeline: string;
  latestAnnouncement: string;
  publishAnnouncement: string;
  newAnnouncement: string;
  editAnnouncement: string;
  archiveAnnouncement: string;
  republishAnnouncement: string;
  announcementActions: string;
  announcementExpiresAt: string;
  announcementNeverExpires: string;
  announcementStatus: string;
  announcementPublished: string;
  announcementArchived: string;
  announcementExpired: string;
  acknowledgements: string;
  deliveryStatus: string;
  organizationIntelligence: string;
  operationalPulse: string;
  requestIntelligenceSnapshot: string;
  latestInsight: string;
  recommendation: string;
  riskLevel: string;
  connectedPeople: string;
  platformOperations: string;
  runReadinessCheck: string;
  readinessStatus: string;
  releaseGate: string;
  productionProtection: string;
  auditHistory: string;
  latestRun: string;
  launchHardening: string;
  runLaunchReview: string;
  launchReadiness: string;
  productionApproval: string;
  rollbackPlan: string;
  migrationReview: string;
  monitoringPlan: string;
  qualityGates: string;
  unresolvedIssues: string;
  migrationReadiness: string;
  runMigrationReview: string;
  dataPolicy: string;
  uidPolicy: string;
  adminRolePolicy: string;
  legacyRulesRisk: string;
  preservationCandidates: string;
  blockers: string;
  migrationMapping: string;
  runMappingReview: string;
  mappingDecision: string;
  mappingSource: string;
  identityMapping: string;
  prayerMapping: string;
  ramadanMapping: string;
  functionMapping: string;
  storageMapping: string;
  legacyCollections: string;
  legacyFunctions: string;
  mappedItems: string;
  blockedItems: string;
  productionPreflight: string;
  runPreflightReview: string;
  preflightDecision: string;
  credentialPolicy: string;
  deploymentPolicy: string;
  githubEnvironment: string;
  firebaseProjects: string;
  requiredAccess: string;
  readyItems: string;
  eventEditor: string;
  eventId: string;
  eventStatus: string;
  eventTitle: string;
  eventTitleAr: string;
  eventSummary: string;
  eventSummaryAr: string;
  eventDescription: string;
  eventDescriptionAr: string;
  eventImagePath: string;
  eventImageAlt: string;
  eventImageAltAr: string;
  eventImageFile: string;
  eventLocation: string;
  eventStartsAt: string;
  eventEndsAt: string;
  eventTimezone: string;
  eventCampus: string;
  eventNoCampus: string;
  eventRegistrationEnabled: string;
  eventRegistrationCapacity: string;
  eventRegistrationOpensAt: string;
  eventRegistrationClosesAt: string;
  eventRegistrationCancellationAllowed: string;
  eventWaitlistEnabled: string;
  eventWaitlistCount: string;
  eventWaitlisted: string;
  eventPromoteWaitlist: string;
  eventWaitlistPromoted: string;
  eventRegistrations: string;
  eventRegistrationCount: string;
  eventNoRegistrations: string;
  eventAttendance: string;
  eventAttendanceCount: string;
  eventNoAttendance: string;
  eventCheckInCredential: string;
  eventCheckInStation: string;
  eventCheckInSubmit: string;
  eventManualSearch: string;
  eventManualCheckIn: string;
  eventAlreadyCheckedIn: string;
  eventNotifyOnPublish: string;
  eventNotifyOnPublishHelp: string;
  eventDraft: string;
  eventScheduled: string;
  eventScheduledPublishDate: string;
  eventScheduledPublishDateHelp: string;
  eventPublished: string;
  eventRegistrationClosedStatus: string;
  eventCancelled: string;
  eventCompleted: string;
  eventArchived: string;
  saveEvent: string;
  resetEventForm: string;
  announcementComposer: string;
  announcementId: string;
  announcementTitle: string;
  announcementTitleAr: string;
  announcementBody: string;
  announcementBodyAr: string;
  announcementPriority: string;
  priorityNormal: string;
  priorityUrgent: string;
  saveAnnouncement: string;
  resetAnnouncementForm: string;
  publishEvent: string;
  latestEvent: string;
  realTimeStatus: string;
  updateStatus: string;
  connectedAs: string;
  language: string;
  directionLabel: string;
};

export const shellCopy: Record<LocaleCode, ShellCopy> = {
  en: {
    appName: "Shdeed",
    environment: "Development environment",
    organization: "Organization",
    welcomeTitle: "Welcome to Shdeed",
    welcomeSubtitle:
      "Find your community, request a basic connection, and watch updates arrive in real time.",
    discoverOrganizations: "Discover organizations",
    requestConnection: "Request connection",
    connectionRequested: "Connection requested",
    connectionRequests: "Connection requests",
    connectionPolicy: "Connection policy",
    communityEvents: "Community events",
    createDonation: "Create donation",
    openConnection: "Open connection",
    firstDonation: "First donation",
    donationTotal: "Donation total",
    latestDonation: "Latest donation",
    stripeConnect: "Stripe Connect",
    stripeConnectHealth: "Stripe Connect health",
    commerceReadiness: "Readiness",
    commerceOnboardingStatus: "Onboarding",
    commerceCharges: "Charges",
    commercePayouts: "Payouts",
    commerceDetailsSubmitted: "Details submitted",
    commerceRequirementsDue: "Requirements due",
    commerceLastSync: "Last provider sync",
    commerceFinanceOnly: "Finance access required.",
    startStripeConnectOnboarding: "Start onboarding",
    resumeStripeConnectOnboarding: "Resume onboarding",
    refreshStripeConnectStatus: "Refresh status",
    stripeConnectNoPayments: "Payments are not processed in this experience.",
    ramadanOperations: "Ramadan operations",
    ramadanCommandCenter: "Ramadan Command Center",
    ramadanTodayTonight: "Today and tonight",
    ramadanPrayerSchedule: "Prayer schedule",
    ramadanTaraweeh: "Taraweeh",
    ramadanQiyam: "Qiyam",
    ramadanIftarCapacity: "Iftar capacity",
    ramadanSponsors: "Sponsors",
    ramadanTransfers: "Transfers",
    ramadanAttentionNeeded: "Attention needed",
    ramadanReadiness: "Readiness",
    ramadanCommunications: "Communications",
    ramadanModeEditor: "Spot price",
    ramadanModeId: "Ramadan mode ID",
    ramadanTitle: "English title",
    ramadanTitleAr: "Arabic title",
    ramadanSummary: "English summary",
    ramadanSummaryAr: "Arabic summary",
    ramadanSlotPriceUsd: "Spot price (USD)",
    saveRamadanMode: "Save spot price",
    resetRamadanModeForm: "Reset price",
    iftarSlotEditor: "Iftar slot editor",
    iftarSlotId: "Iftar slot ID",
    iftarModeId: "Ramadan mode ID",
    iftarDayNumber: "Ramadan day",
    iftarSlotLabel: "English label",
    iftarSlotLabelAr: "Arabic label",
    iftarAmountUsd: "Sponsorship amount (USD)",
    saveIftarSlot: "Save iftar slot",
    resetIftarSlotForm: "Reset iftar slot",
    iftarSponsorships: "Iftar sponsorships",
    ramadanAdminNotes: "Ramadan admin notes",
    saveRamadanAdminNote: "Save note",
    resetRamadanAdminNoteForm: "Reset note",
    availableSlots: "Available slots",
    reserveIftarSlot: "Reserve iftar slot",
    latestSponsorship: "Latest sponsorship",
    reserveSpace: "Reserve space",
    spaces: "Spaces",
    spaceEditor: "Space editor",
    spaceId: "Space ID",
    spaceCampus: "Campus",
    spaceNoCampus: "No campus",
    spaceType: "Type",
    spaceStatus: "Status",
    spaceVisibility: "Visibility",
    spaceName: "English name",
    spaceNameAr: "Arabic name",
    spaceDescription: "English description",
    spaceDescriptionAr: "Arabic description",
    spaceLocation: "Location",
    spaceCapacity: "Capacity",
    spaceAmenities: "Amenities",
    spaceAccessibilityFeatures: "Accessibility features",
    spaceAccessibilityNotes: "Accessibility notes",
    spaceAccessibilityNotesAr: "Accessibility notes (Arabic)",
    spacePrimaryImageStoragePath: "Primary image path",
    spacePrimaryImageAltText: "Primary image alt text",
    spacePrimaryImageAltTextAr: "Primary image alt text (Arabic)",
    spaceTimezone: "Timezone",
    spaceOperatingHours: "Operating hours",
    spaceMondayHours: "Monday hours",
    spaceTuesdayHours: "Tuesday hours",
    spaceWednesdayHours: "Wednesday hours",
    spaceThursdayHours: "Thursday hours",
    spaceFridayHours: "Friday hours",
    spaceSaturdayHours: "Saturday hours",
    spaceSundayHours: "Sunday hours",
    spaceHourlyPriceUsd: "Legacy hourly price (USD)",
    saveSpace: "Save space",
    resetSpaceForm: "Reset space",
    spaceAvailabilityBlocks: "Availability blocks",
    spaceAvailabilityBlockEditor: "Availability block editor",
    spaceAvailabilityBlockId: "Block ID",
    spaceAvailabilityBlockType: "Block type",
    spaceAvailabilityBlockStartsAt: "Starts at",
    spaceAvailabilityBlockEndsAt: "Ends at",
    spaceAvailabilityBlockLabel: "English label",
    spaceAvailabilityBlockLabelAr: "Arabic label",
    spaceAvailabilityBlockInternalReason: "Internal reason",
    spaceAvailabilityBlockPublicReason: "Public reason",
    saveSpaceAvailabilityBlock: "Save availability block",
    resetSpaceAvailabilityBlockForm: "Reset availability block",
    spaceReservationRequests: "Space reservation requests",
    pendingSpaceReservationRequests: "Pending space requests",
    approvedSpaceReservationSchedule: "Approved space schedule",
    canonicalSpaceReservations: "Canonical reservations",
    approveSpaceReservation: "Approve",
    rejectSpaceReservation: "Reject",
    cancelSpaceReservation: "Cancel",
    availableSpaceSlots: "Available space slots",
    spaceSlotEditor: "Space slot editor",
    spaceSlotId: "Slot ID",
    spaceSlotSpaceId: "Space ID",
    spaceSlotLabel: "English label",
    spaceSlotLabelAr: "Arabic label",
    spaceSlotStartsAt: "Starts at",
    spaceSlotEndsAt: "Ends at",
    spaceSlotAmountUsd: "Reservation amount (USD)",
    saveSpaceSlot: "Save space slot",
    resetSpaceSlotForm: "Reset space slot",
    latestReservation: "Latest reservation",
    publishSpace: "Publish space",
    organizationProfileEditor: "Organization profile editor",
    organizationIdentityDetails: "Identity",
    organizationDisplayName: "Display name",
    organizationLogoStoragePath: "Logo storage path",
    organizationLogoFile: "Upload logo",
    organizationLocationDetails: "Location",
    organizationAddressLine1: "Address line 1",
    organizationAddressLine2: "Address line 2",
    organizationCity: "City",
    organizationRegion: "State / region",
    organizationPostalCode: "Postal code",
    organizationCountry: "Country code",
    organizationTimeZone: "Timezone",
    organizationPublicContact: "Public contact",
    organizationNoPublicContact: "No public contact set",
    organizationPublicEmail: "Public email",
    organizationPublicPhone: "Public phone",
    organizationWebsiteUrl: "Website URL",
    organizationPublicVisibility: "Public visibility",
    organizationVisibilityDirectory: "Directory",
    organizationVisibilityDiscovery: "Discovery",
    organizationVisibilityProfile: "Profile page",
    organizationBrandColor: "Brand color",
    organizationCategory: "Category",
    organizationConnectionPolicy: "Connection policy",
    policyOpen: "Open auto-approval",
    policyApprovalRequired: "Approval required",
    organizationWelcomeCopy: "Welcome copy",
    organizationHeadline: "English headline",
    organizationHeadlineAr: "Arabic headline",
    organizationSummary: "English summary",
    organizationSummaryAr: "Arabic summary",
    saveOrganizationProfile: "Save profile",
    resetOrganizationProfileForm: "Reset profile",
    editOrganizationProfile: "Edit profile",
    organizationProfileAudit: "Profile audit",
    prayerTimesSettings: "Prayer times settings",
    prayerTimesEnabled: "Show prayer times in the mobile app",
    prayerTimesMobileVisibility: "Controls public mobile visibility.",
    configurePrayerTimes: "Configure prayer times",
    prayerProvider: "Provider",
    prayerAddress: "Prayer address",
    prayerCalculationMethod: "Calculation method",
    prayerSchool: "Asr school",
    prayerLatitudeAdjustment: "Higher-latitude adjustment",
    prayerIqamaTimes: "Iqama times",
    prayerTimingsDate: "Timings date",
    prayerSource: "Source",
    prayerFajr: "Fajr",
    prayerSunrise: "Sunrise",
    prayerDhuhr: "Dhuhr",
    prayerAsr: "Asr",
    prayerMaghrib: "Maghrib",
    prayerIsha: "Isha",
    prayerJumuah: "Jumuah",
    adhan: "Adhan",
    iqamah: "Iqama",
    savePrayerSettings: "Save prayer settings",
    resetPrayerSettingsForm: "Reset prayer settings",
    peopleManager: "People manager",
    approveConnection: "Approve",
    rejectConnection: "Reject",
    connectionDecisions: "Connection decisions",
    communityEngagement: "Community engagement",
    imamContent: "Leadership profiles",
    imamContentEditor: "Leadership profile editor",
    imamContentId: "Content ID",
    imamContentStatus: "Status",
    imamContentTitle: "English title",
    imamContentTitleAr: "Arabic title",
    imamContentSubtitle: "English subtitle",
    imamContentSubtitleAr: "Arabic subtitle",
    imamContentBody: "English body",
    imamContentBodyAr: "Arabic body",
    imamContentImagePath: "Image storage path",
    imamContentImageAlt: "Image alt text",
    imamContentImageAltAr: "Arabic image alt text",
    imamContentImageFile: "Upload profile image",
    imamContentGalleryImageFiles: "Upload gallery images",
    imamContentYoutubeUrl: "YouTube video URL",
    imamContentDraft: "Draft",
    imamContentPublished: "Published",
    imamContentArchived: "Disabled",
    publishImamContent: "Publish profile",
    disableImamContent: "Disable profile",
    deleteImamContent: "Delete profile",
    imamContentSortOrder: "Sort order",
    imamContentFeatured: "Featured",
    imamContentEmpty: "No leadership profiles yet.",
    newImamContent: "New profile",
    editImamContent: "Edit profile",
    imamContentImagePreview: "Photo",
    imamContentMedia: "Media",
    imamContentActions: "Actions",
    saveImamContent: "Save profile",
    resetImamContentForm: "Reset profile",
    announcements: "Announcements",
    communityTimeline: "Community timeline",
    latestAnnouncement: "Latest announcement",
    publishAnnouncement: "Publish announcement",
    newAnnouncement: "New announcement",
    editAnnouncement: "Edit announcement",
    archiveAnnouncement: "Archive announcement",
    republishAnnouncement: "Republish announcement",
    announcementActions: "Actions",
    announcementExpiresAt: "Expiration date",
    announcementNeverExpires: "No expiration",
    announcementStatus: "Status",
    announcementPublished: "Published",
    announcementArchived: "Archived",
    announcementExpired: "Expired",
    acknowledgements: "Acknowledgements",
    deliveryStatus: "Delivery status",
    organizationIntelligence: "Dashboard",
    operationalPulse: "Operational pulse",
    requestIntelligenceSnapshot: "Request pulse",
    latestInsight: "Latest insight",
    recommendation: "Recommendation",
    riskLevel: "Risk level",
    connectedPeople: "Connected people",
    platformOperations: "Platform operations",
    runReadinessCheck: "Run readiness check",
    readinessStatus: "Readiness status",
    releaseGate: "Release gate",
    productionProtection: "Production protection",
    auditHistory: "Audit history",
    latestRun: "Latest run",
    launchHardening: "Launch hardening",
    runLaunchReview: "Run launch review",
    launchReadiness: "Launch readiness",
    productionApproval: "Production approval",
    rollbackPlan: "Rollback plan",
    migrationReview: "Migration review",
    monitoringPlan: "Monitoring plan",
    qualityGates: "Quality gates",
    unresolvedIssues: "Unresolved issues",
    migrationReadiness: "Migration readiness",
    runMigrationReview: "Run migration review",
    dataPolicy: "Data policy",
    uidPolicy: "UID policy",
    adminRolePolicy: "Admin role policy",
    legacyRulesRisk: "Legacy rules risk",
    preservationCandidates: "Preservation candidates",
    blockers: "Blockers",
    migrationMapping: "Migration mapping",
    runMappingReview: "Run mapping review",
    mappingDecision: "Mapping decision",
    mappingSource: "Mapping source",
    identityMapping: "Identity mapping",
    prayerMapping: "Prayer mapping",
    ramadanMapping: "Ramadan mapping",
    functionMapping: "Function mapping",
    storageMapping: "Storage mapping",
    legacyCollections: "Legacy collections",
    legacyFunctions: "Legacy functions",
    mappedItems: "Mapped items",
    blockedItems: "Blocked items",
    productionPreflight: "Production preflight",
    runPreflightReview: "Run preflight review",
    preflightDecision: "Preflight decision",
    credentialPolicy: "Credential policy",
    deploymentPolicy: "Deployment policy",
    githubEnvironment: "GitHub environment",
    firebaseProjects: "Firebase projects",
    requiredAccess: "Required access",
    readyItems: "Ready items",
    eventEditor: "Event editor",
    eventId: "Event ID",
    eventStatus: "Status",
    eventTitle: "Title (English)",
    eventTitleAr: "Title (Arabic)",
    eventSummary: "Summary (English)",
    eventSummaryAr: "Summary (Arabic)",
    eventDescription: "Description (English)",
    eventDescriptionAr: "Description (Arabic)",
    eventImagePath: "Image storage path",
    eventImageAlt: "Image alt text",
    eventImageAltAr: "Arabic image alt text",
    eventImageFile: "Upload image",
    eventLocation: "Location",
    eventStartsAt: "Starts at",
    eventEndsAt: "Ends at",
    eventTimezone: "Time zone",
    eventCampus: "Campus",
    eventNoCampus: "No campus",
    eventRegistrationEnabled: "Enable registration",
    eventRegistrationCapacity: "Registration capacity",
    eventRegistrationOpensAt: "Registration opens",
    eventRegistrationClosesAt: "Registration closes",
    eventRegistrationCancellationAllowed: "Allow cancellation",
    eventWaitlistEnabled: "Enable waitlist",
    eventWaitlistCount: "Waitlist",
    eventWaitlisted: "Waitlisted",
    eventPromoteWaitlist: "Promote",
    eventWaitlistPromoted: "Waitlist promoted",
    eventRegistrations: "Event registrations",
    eventRegistrationCount: "Confirmed registrations",
    eventNoRegistrations: "No registrations for the selected event.",
    eventAttendance: "Event check-in",
    eventAttendanceCount: "Checked in",
    eventNoAttendance: "No check-ins yet.",
    eventCheckInCredential: "QR credential",
    eventCheckInStation: "Station label",
    eventCheckInSubmit: "Check in QR",
    eventManualSearch: "Search registrations",
    eventManualCheckIn: "Manual check-in",
    eventAlreadyCheckedIn: "Already checked in",
    eventNotifyOnPublish: "Prepare publish notification",
    eventNotifyOnPublishHelp:
      "Stores the publish notification intent. Use the event detail notification panel to review, edit, and send email or push.",
    eventDraft: "Draft",
    eventScheduled: "Scheduled",
    eventScheduledPublishDate: "Scheduled publish date",
    eventScheduledPublishDateHelp: "Publishes at 12:00 AM in the selected time zone.",
    eventPublished: "Published",
    eventRegistrationClosedStatus: "Registration closed",
    eventCancelled: "Cancelled",
    eventCompleted: "Completed",
    eventArchived: "Archived",
    saveEvent: "Save event",
    resetEventForm: "Reset form",
    announcementComposer: "Announcement composer",
    announcementId: "Announcement ID",
    announcementTitle: "English title",
    announcementTitleAr: "Arabic title",
    announcementBody: "English body",
    announcementBodyAr: "Arabic body",
    announcementPriority: "Priority",
    priorityNormal: "Normal",
    priorityUrgent: "Urgent",
    saveAnnouncement: "Save announcement",
    resetAnnouncementForm: "Reset announcement",
    publishEvent: "Publish event",
    latestEvent: "Latest event",
    realTimeStatus: "Real-time status",
    updateStatus: "Update status",
    connectedAs: "Connected as",
    language: "Language",
    directionLabel: "Left to right",
  },
  ar: {
    appName: "شديد",
    environment: "بيئة التطوير",
    organization: "المؤسسة",
    welcomeTitle: "مرحباً بك في شديد",
    welcomeSubtitle: "ابحث عن مجتمعك، واطلب اتصالاً أساسياً، وشاهد التحديثات فور وصولها.",
    discoverOrganizations: "استكشاف المؤسسات",
    requestConnection: "طلب الاتصال",
    connectionRequested: "تم إرسال الطلب",
    connectionRequests: "طلبات الاتصال",
    connectionPolicy: "سياسة الاتصال",
    communityEvents: "فعاليات المجتمع",
    createDonation: "إنشاء تبرع",
    openConnection: "اتصال مفتوح",
    firstDonation: "أول تبرع",
    donationTotal: "إجمالي التبرعات",
    latestDonation: "آخر تبرع",
    stripeConnect: "Stripe Connect",
    stripeConnectHealth: "حالة Stripe Connect",
    commerceReadiness: "الجاهزية",
    commerceOnboardingStatus: "إعداد الحساب",
    commerceCharges: "المدفوعات",
    commercePayouts: "التحويلات",
    commerceDetailsSubmitted: "تم إرسال التفاصيل",
    commerceRequirementsDue: "المتطلبات المطلوبة",
    commerceLastSync: "آخر مزامنة مع المزود",
    commerceFinanceOnly: "يتطلب صلاحية مالية.",
    startStripeConnectOnboarding: "بدء الإعداد",
    resumeStripeConnectOnboarding: "متابعة الإعداد",
    refreshStripeConnectStatus: "تحديث الحالة",
    stripeConnectNoPayments: "لا تتم معالجة المدفوعات في هذه التجربة.",
    ramadanOperations: "عمليات رمضان",
    ramadanCommandCenter: "مركز قيادة رمضان",
    ramadanTodayTonight: "اليوم والليلة",
    ramadanPrayerSchedule: "جدول الصلاة",
    ramadanTaraweeh: "التراويح",
    ramadanQiyam: "القيام",
    ramadanIftarCapacity: "سعة الإفطار",
    ramadanSponsors: "الرعاة",
    ramadanTransfers: "النقل",
    ramadanAttentionNeeded: "بحاجة إلى متابعة",
    ramadanReadiness: "الجاهزية",
    ramadanCommunications: "التواصل",
    ramadanModeEditor: "سعر الخانة",
    ramadanModeId: "معرف وضع رمضان",
    ramadanTitle: "العنوان بالإنجليزية",
    ramadanTitleAr: "العنوان بالعربية",
    ramadanSummary: "الملخص بالإنجليزية",
    ramadanSummaryAr: "الملخص بالعربية",
    ramadanSlotPriceUsd: "سعر خانة الرعاية بالدولار",
    saveRamadanMode: "حفظ السعر",
    resetRamadanModeForm: "إعادة ضبط السعر",
    iftarSlotEditor: "محرر خانة الإفطار",
    iftarSlotId: "معرف خانة الإفطار",
    iftarModeId: "معرف وضع رمضان",
    iftarDayNumber: "يوم رمضان",
    iftarSlotLabel: "التسمية بالإنجليزية",
    iftarSlotLabelAr: "التسمية بالعربية",
    iftarAmountUsd: "قيمة الرعاية بالدولار",
    saveIftarSlot: "حفظ خانة الإفطار",
    resetIftarSlotForm: "إعادة ضبط خانة الإفطار",
    iftarSponsorships: "رعايات الإفطار",
    ramadanAdminNotes: "ملاحظات إدارة رمضان",
    saveRamadanAdminNote: "حفظ الملاحظة",
    resetRamadanAdminNoteForm: "إعادة ضبط الملاحظة",
    availableSlots: "الخانات المتاحة",
    reserveIftarSlot: "حجز رعاية إفطار",
    latestSponsorship: "آخر رعاية",
    reserveSpace: "حجز مساحة",
    spaces: "المساحات",
    spaceEditor: "محرر المساحة",
    spaceId: "معرف المساحة",
    spaceCampus: "الحرم",
    spaceNoCampus: "بدون حرم",
    spaceType: "النوع",
    spaceStatus: "الحالة",
    spaceVisibility: "الظهور",
    spaceName: "الاسم بالإنجليزية",
    spaceNameAr: "الاسم بالعربية",
    spaceDescription: "الوصف بالإنجليزية",
    spaceDescriptionAr: "الوصف بالعربية",
    spaceLocation: "الموقع",
    spaceCapacity: "السعة",
    spaceAmenities: "المزايا",
    spaceAccessibilityFeatures: "مزايا الوصول",
    spaceAccessibilityNotes: "ملاحظات الوصول",
    spaceAccessibilityNotesAr: "ملاحظات الوصول بالعربية",
    spacePrimaryImageStoragePath: "مسار الصورة الرئيسية",
    spacePrimaryImageAltText: "نص بديل للصورة الرئيسية",
    spacePrimaryImageAltTextAr: "النص البديل للصورة الرئيسية بالعربية",
    spaceTimezone: "المنطقة الزمنية",
    spaceOperatingHours: "ساعات التشغيل",
    spaceMondayHours: "ساعات الاثنين",
    spaceTuesdayHours: "ساعات الثلاثاء",
    spaceWednesdayHours: "ساعات الأربعاء",
    spaceThursdayHours: "ساعات الخميس",
    spaceFridayHours: "ساعات الجمعة",
    spaceSaturdayHours: "ساعات السبت",
    spaceSundayHours: "ساعات الأحد",
    spaceHourlyPriceUsd: "السعر القديم بالساعة بالدولار",
    saveSpace: "حفظ المساحة",
    resetSpaceForm: "إعادة ضبط المساحة",
    spaceAvailabilityBlocks: "فترات عدم الإتاحة",
    spaceAvailabilityBlockEditor: "محرر فترة عدم الإتاحة",
    spaceAvailabilityBlockId: "معرف الفترة",
    spaceAvailabilityBlockType: "نوع الفترة",
    spaceAvailabilityBlockStartsAt: "تبدأ في",
    spaceAvailabilityBlockEndsAt: "تنتهي في",
    spaceAvailabilityBlockLabel: "التسمية بالإنجليزية",
    spaceAvailabilityBlockLabelAr: "التسمية بالعربية",
    spaceAvailabilityBlockInternalReason: "السبب الداخلي",
    spaceAvailabilityBlockPublicReason: "إظهار السبب",
    saveSpaceAvailabilityBlock: "حفظ فترة عدم الإتاحة",
    resetSpaceAvailabilityBlockForm: "إعادة ضبط فترة عدم الإتاحة",
    spaceReservationRequests: "طلبات حجز المساحات",
    pendingSpaceReservationRequests: "طلبات المساحات المعلقة",
    approvedSpaceReservationSchedule: "جدول المساحات المعتمدة",
    canonicalSpaceReservations: "الحجوزات الرسمية",
    approveSpaceReservation: "اعتماد",
    rejectSpaceReservation: "رفض",
    cancelSpaceReservation: "إلغاء",
    availableSpaceSlots: "خانات المساحات المتاحة",
    spaceSlotEditor: "محرر خانة المساحة",
    spaceSlotId: "معرف الخانة",
    spaceSlotSpaceId: "معرف المساحة",
    spaceSlotLabel: "التسمية بالإنجليزية",
    spaceSlotLabelAr: "التسمية بالعربية",
    spaceSlotStartsAt: "تبدأ في",
    spaceSlotEndsAt: "تنتهي في",
    spaceSlotAmountUsd: "قيمة الحجز بالدولار",
    saveSpaceSlot: "حفظ خانة المساحة",
    resetSpaceSlotForm: "إعادة ضبط خانة المساحة",
    latestReservation: "آخر حجز",
    publishSpace: "نشر المساحة",
    organizationProfileEditor: "محرر ملف المؤسسة",
    organizationIdentityDetails: "الهوية",
    organizationDisplayName: "اسم العرض",
    organizationLogoStoragePath: "مسار الشعار في التخزين",
    organizationLogoFile: "رفع الشعار",
    organizationLocationDetails: "الموقع",
    organizationAddressLine1: "العنوان ١",
    organizationAddressLine2: "العنوان ٢",
    organizationCity: "المدينة",
    organizationRegion: "الولاية / المنطقة",
    organizationPostalCode: "الرمز البريدي",
    organizationCountry: "رمز الدولة",
    organizationTimeZone: "المنطقة الزمنية",
    organizationPublicContact: "معلومات التواصل العامة",
    organizationNoPublicContact: "لم يتم تعيين معلومات تواصل عامة",
    organizationPublicEmail: "البريد العام",
    organizationPublicPhone: "الهاتف العام",
    organizationWebsiteUrl: "رابط الموقع",
    organizationPublicVisibility: "الظهور العام",
    organizationVisibilityDirectory: "الدليل",
    organizationVisibilityDiscovery: "الاكتشاف",
    organizationVisibilityProfile: "صفحة الملف",
    organizationBrandColor: "لون الهوية",
    organizationCategory: "الفئة",
    organizationConnectionPolicy: "سياسة الاتصال",
    policyOpen: "قبول تلقائي مفتوح",
    policyApprovalRequired: "يتطلب موافقة",
    organizationWelcomeCopy: "نص الترحيب",
    organizationHeadline: "العنوان بالإنجليزية",
    organizationHeadlineAr: "العنوان بالعربية",
    organizationSummary: "الملخص بالإنجليزية",
    organizationSummaryAr: "الملخص بالعربية",
    saveOrganizationProfile: "حفظ الملف",
    resetOrganizationProfileForm: "إعادة ضبط الملف",
    editOrganizationProfile: "تعديل الملف",
    organizationProfileAudit: "سجل تغييرات الملف",
    prayerTimesSettings: "إعدادات أوقات الصلاة",
    prayerTimesEnabled: "إظهار أوقات الصلاة في تطبيق الجوال",
    prayerTimesMobileVisibility: "يتحكم في الظهور العام على تطبيق الجوال.",
    configurePrayerTimes: "ضبط أوقات الصلاة",
    prayerProvider: "المزوّد",
    prayerAddress: "عنوان حساب الصلاة",
    prayerCalculationMethod: "طريقة الحساب",
    prayerSchool: "مذهب العصر",
    prayerLatitudeAdjustment: "تصحيح خطوط العرض العالية",
    prayerIqamaTimes: "أوقات الإقامة",
    prayerTimingsDate: "تاريخ الأوقات",
    prayerSource: "المصدر",
    prayerFajr: "الفجر",
    prayerSunrise: "الشروق",
    prayerDhuhr: "الظهر",
    prayerAsr: "العصر",
    prayerMaghrib: "المغرب",
    prayerIsha: "العشاء",
    prayerJumuah: "الجمعة",
    adhan: "الأذان",
    iqamah: "الإقامة",
    savePrayerSettings: "حفظ إعدادات الصلاة",
    resetPrayerSettingsForm: "إعادة ضبط إعدادات الصلاة",
    peopleManager: "إدارة الأشخاص",
    approveConnection: "قبول",
    rejectConnection: "رفض",
    connectionDecisions: "قرارات الاتصال",
    communityEngagement: "تفاعل المجتمع",
    imamContent: "ملفات القيادة الدينية",
    imamContentEditor: "محرر ملف القيادة الدينية",
    imamContentId: "معرف المحتوى",
    imamContentStatus: "الحالة",
    imamContentTitle: "العنوان بالإنجليزية",
    imamContentTitleAr: "العنوان بالعربية",
    imamContentSubtitle: "العنوان الفرعي بالإنجليزية",
    imamContentSubtitleAr: "العنوان الفرعي بالعربية",
    imamContentBody: "النص بالإنجليزية",
    imamContentBodyAr: "النص بالعربية",
    imamContentImagePath: "مسار الصورة في التخزين",
    imamContentImageAlt: "وصف الصورة بالإنجليزية",
    imamContentImageAltAr: "وصف الصورة بالعربية",
    imamContentImageFile: "رفع صورة الملف",
    imamContentGalleryImageFiles: "رفع صور إضافية",
    imamContentYoutubeUrl: "رابط فيديو YouTube",
    imamContentDraft: "مسودة",
    imamContentPublished: "منشور",
    imamContentArchived: "معطل",
    publishImamContent: "نشر الملف",
    disableImamContent: "تعطيل الملف",
    deleteImamContent: "حذف الملف",
    imamContentSortOrder: "ترتيب العرض",
    imamContentFeatured: "مميز",
    imamContentEmpty: "لا توجد ملفات قيادة دينية بعد.",
    newImamContent: "ملف جديد",
    editImamContent: "تعديل الملف",
    imamContentImagePreview: "الصورة",
    imamContentMedia: "الوسائط",
    imamContentActions: "الإجراءات",
    saveImamContent: "حفظ الملف",
    resetImamContentForm: "إعادة ضبط الملف",
    announcements: "الإعلانات",
    communityTimeline: "خط المجتمع الزمني",
    latestAnnouncement: "آخر إعلان",
    publishAnnouncement: "نشر إعلان",
    newAnnouncement: "إعلان جديد",
    editAnnouncement: "تعديل الإعلان",
    archiveAnnouncement: "أرشفة الإعلان",
    republishAnnouncement: "إعادة نشر الإعلان",
    announcementActions: "الإجراءات",
    announcementExpiresAt: "تاريخ انتهاء الإعلان",
    announcementNeverExpires: "بدون انتهاء",
    announcementStatus: "الحالة",
    announcementPublished: "منشور",
    announcementArchived: "مؤرشف",
    announcementExpired: "منتهي",
    acknowledgements: "التأكيدات",
    deliveryStatus: "حالة التسليم",
    organizationIntelligence: "لوحة التحكم",
    operationalPulse: "نبض العمليات",
    requestIntelligenceSnapshot: "طلب النبض",
    latestInsight: "آخر رؤية",
    recommendation: "التوصية",
    riskLevel: "مستوى المخاطر",
    connectedPeople: "الأشخاص المتصلون",
    platformOperations: "عمليات المنصة",
    runReadinessCheck: "تشغيل فحص الجاهزية",
    readinessStatus: "حالة الجاهزية",
    releaseGate: "بوابة الإصدار",
    productionProtection: "حماية الإنتاج",
    auditHistory: "سجل التدقيق",
    latestRun: "آخر تشغيل",
    launchHardening: "تقوية الإطلاق",
    runLaunchReview: "تشغيل مراجعة الإطلاق",
    launchReadiness: "جاهزية الإطلاق",
    productionApproval: "موافقة الإنتاج",
    rollbackPlan: "خطة الرجوع",
    migrationReview: "مراجعة الهجرة",
    monitoringPlan: "خطة المراقبة",
    qualityGates: "بوابات الجودة",
    unresolvedIssues: "المشكلات المفتوحة",
    migrationReadiness: "جاهزية الهجرة",
    runMigrationReview: "تشغيل مراجعة الهجرة",
    dataPolicy: "سياسة البيانات",
    uidPolicy: "سياسة معرفات UID",
    adminRolePolicy: "سياسة أدوار الإدارة",
    legacyRulesRisk: "مخاطر القواعد القديمة",
    preservationCandidates: "مرشحات الحفظ",
    blockers: "العوائق",
    migrationMapping: "خريطة الهجرة",
    runMappingReview: "تشغيل مراجعة الخريطة",
    mappingDecision: "قرار الخريطة",
    mappingSource: "مصدر الخريطة",
    identityMapping: "ربط الهوية",
    prayerMapping: "ربط الصلاة",
    ramadanMapping: "ربط رمضان",
    functionMapping: "ربط الوظائف",
    storageMapping: "ربط التخزين",
    legacyCollections: "مجموعات النظام القديم",
    legacyFunctions: "وظائف النظام القديم",
    mappedItems: "العناصر المربوطة",
    blockedItems: "العناصر المعطلة",
    productionPreflight: "فحص الإنتاج التمهيدي",
    runPreflightReview: "تشغيل فحص الإنتاج",
    preflightDecision: "قرار الفحص التمهيدي",
    credentialPolicy: "سياسة بيانات الاعتماد",
    deploymentPolicy: "سياسة النشر",
    githubEnvironment: "بيئة GitHub",
    firebaseProjects: "مشاريع Firebase",
    requiredAccess: "الوصول المطلوب",
    readyItems: "العناصر الجاهزة",
    eventEditor: "محرر الفعاليات",
    eventId: "معرف الفعالية",
    eventStatus: "الحالة",
    eventTitle: "العنوان بالإنجليزية",
    eventTitleAr: "العنوان بالعربية",
    eventSummary: "الملخص بالإنجليزية",
    eventSummaryAr: "الملخص بالعربية",
    eventDescription: "الوصف بالإنجليزية",
    eventDescriptionAr: "الوصف بالعربية",
    eventImagePath: "مسار الصورة في التخزين",
    eventImageAlt: "وصف الصورة بالإنجليزية",
    eventImageAltAr: "وصف الصورة بالعربية",
    eventImageFile: "رفع صورة",
    eventLocation: "الموقع",
    eventStartsAt: "تبدأ في",
    eventEndsAt: "تنتهي في",
    eventTimezone: "المنطقة الزمنية",
    eventCampus: "الحرم",
    eventNoCampus: "بدون حرم",
    eventRegistrationEnabled: "تفعيل التسجيل",
    eventRegistrationCapacity: "سعة التسجيل",
    eventRegistrationOpensAt: "يفتح التسجيل",
    eventRegistrationClosesAt: "يغلق التسجيل",
    eventRegistrationCancellationAllowed: "السماح بالإلغاء",
    eventWaitlistEnabled: "تفعيل قائمة الانتظار",
    eventWaitlistCount: "قائمة الانتظار",
    eventWaitlisted: "في قائمة الانتظار",
    eventPromoteWaitlist: "ترقية",
    eventWaitlistPromoted: "تمت ترقية قائمة الانتظار",
    eventRegistrations: "تسجيلات الفعالية",
    eventRegistrationCount: "التسجيلات المؤكدة",
    eventNoRegistrations: "لا توجد تسجيلات للفعالية المحددة.",
    eventAttendance: "تسجيل الحضور",
    eventAttendanceCount: "تم تسجيل حضورهم",
    eventNoAttendance: "لا توجد عمليات تسجيل حضور بعد.",
    eventCheckInCredential: "رمز QR",
    eventCheckInStation: "اسم المحطة",
    eventCheckInSubmit: "تسجيل حضور QR",
    eventManualSearch: "بحث في التسجيلات",
    eventManualCheckIn: "تسجيل حضور يدوي",
    eventAlreadyCheckedIn: "تم تسجيل الحضور",
    eventNotifyOnPublish: "تحضير إشعار النشر",
    eventNotifyOnPublishHelp:
      "يحفظ نية إشعار النشر. استخدم لوحة إشعارات تفاصيل الفعالية للمراجعة والتعديل وإرسال البريد أو الدفع.",
    eventDraft: "مسودة",
    eventScheduled: "مجدولة",
    eventScheduledPublishDate: "تاريخ النشر المجدول",
    eventScheduledPublishDateHelp: "يتم النشر عند الساعة 12:00 صباحاً حسب المنطقة الزمنية المحددة.",
    eventPublished: "منشورة",
    eventRegistrationClosedStatus: "التسجيل مغلق",
    eventCancelled: "ملغاة",
    eventCompleted: "مكتملة",
    eventArchived: "مؤرشفة",
    saveEvent: "حفظ الفعالية",
    resetEventForm: "إعادة ضبط النموذج",
    announcementComposer: "محرر الإعلانات",
    announcementId: "معرف الإعلان",
    announcementTitle: "العنوان بالإنجليزية",
    announcementTitleAr: "العنوان بالعربية",
    announcementBody: "النص بالإنجليزية",
    announcementBodyAr: "النص بالعربية",
    announcementPriority: "الأولوية",
    priorityNormal: "عادية",
    priorityUrgent: "عاجلة",
    saveAnnouncement: "حفظ الإعلان",
    resetAnnouncementForm: "إعادة ضبط الإعلان",
    publishEvent: "نشر الفعالية",
    latestEvent: "آخر فعالية",
    realTimeStatus: "حالة التحديث المباشر",
    updateStatus: "تحديث الحالة",
    connectedAs: "متصل باسم",
    language: "اللغة",
    directionLabel: "من اليمين إلى اليسار",
  },
};

export function directionForLocale(locale: LocaleCode): "ltr" | "rtl" {
  return locale === "ar" ? "rtl" : "ltr";
}
